(ns hai.ui.components.section-toggle
  "Touch-sized collapsible-section header: a chevron + uppercase label + count
   button that rotates its chevron when `.open`. Shared by the mobile
   dashboard's mini-app sections ([[hai.home.mobile.mini-apps]]) and the
   kanban view's lane headers on narrow screens."
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def chevron-icon (icons/mui-icon :outlined :chevron_right))

(o/defstyled section-toggle :button
  {:display "flex" :align-items "center" :gap "10px"
   :width "100%"
   :padding "12px 16px"
   :border "none" :background "transparent"
   :font-family "inherit"
   :text-align "left"
   :cursor "pointer"
   :transition "background 0.15s ease"}
  [:at-media {:hover "hover"}
   [:&:hover {:background t/--note-kraft-10}]]
  [:.section-chevron
   {:display "inline-flex" :align-items "center"
    :color t/--note-kraft}
   [:svg {:width "16px" :height "16px" :fill "currentColor"
          :transition "transform 0.15s ease"}]]
  [:&.open [:.section-chevron [:svg {:transform "rotate(90deg)"}]]]
  ;; Sized to match the notes card's eyebrow, like the desktop frame's section.
  [:.section-label
   {:font-size "11px" :font-weight "700"
    :letter-spacing "0.06em" :text-transform "uppercase"
    :color t/--note-kraft}]
  [:.section-count
   {:font-size "11px" :font-weight "500"
    :color t/--link-muted}])
